// extracted by mini-css-extract-plugin
module.exports = {"loading":"PageLoading_loading__3HLk7","loadingShrink":"PageLoading_loadingShrink__1NjSC"};